import getEstateBaseRouteName from './getEstateBaseRouteName'
import type { EstateType } from '~/types/EstateType'

export default function getEstateMapRouteName(estateType: EstateType) {
  return `${getEstateBaseRouteName(estateType)}-map`
}
